import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXFormFieldError',
  props: {
  errors: {
    type: Array as PropType<{ label: string; message: string }[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;



const errorMarkdown = computed(() => props.errors.map((error) => error.message.replaceAll('{field}', `**${error.label}**`)).join(', '));

return { __sfc: true,props, errorMarkdown, BCXMarkdown }
}

})